import React from 'react';
import { Link } from 'react-router-dom';

const StudentResources = () => {
    const resources = [
        {
            name: "Online Classes",
            path: "/online-classes",
            icon: "bi-laptop",
            description: "Access your virtual classrooms and learning materials"
        },
        {
            name: "Library Resources & Journals",
            path: "/library-resources",
            icon: "bi-journal-bookmark-fill",
            description: "Access our extensive collection of academic journals and library resources"
        },
        {
            name: "Videos and References",
            path: "/videos-and-references",
            icon: "bi-play-circle-fill",
            description: "Educational videos and reference materials"
        },
        {
            name: "Institutional Repository",
            path: "https://aru-online.com/research/index.html",
            icon: "bi-database-fill",
            description: "Explore our digital collection of research outputs and scholarly content"
        },
        {
            name: "Student Questionnaire",
            path: "/student-questionnaire",
            icon: "bi-clipboard2-pulse-fill",
            description: "Provide feedback through our student surveys"
        },
        {
            name: "Student Union",
            path: "/student-union",
            icon: "bi-people-fill",
            description: "View elected student leaders, the constitution, and election access"
        },
        {
            name: "Student Info & Downloads",
            path: "/student-info-downloads",
            icon: "bi-download",
            description: "Important documents and forms for students"
        },
        {
            name: "Student Enquiries & Complaints",
            path: "/student-enquiries",
            icon: "bi-question-circle-fill",
            description: "Submit your questions or concerns to our support team"
        },
    ];

    return (
        <div className="min-h-screen pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Student Resources</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Access all your academic resources and support services in one place
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {resources.map((resource, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100"
                        >
                            <div className="p-6">
                                <div className="flex items-center mb-4">
                                    <div className="p-2 bg-green-100 rounded-lg text-green-600 mr-4">
                                        <i className={`bi ${resource.icon} text-2xl`}></i>
                                    </div>
                                    <h3 className="text-xl font-semibold text-gray-900">{resource.name}</h3>
                                </div>
                                <p className="text-gray-600 mb-6">{resource.description}</p>
                                <div className="mt-auto">
                                    {resource.path.startsWith('http') ? (
                                        <a
                                            href={resource.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-flex items-center text-green-600 hover:text-green-700 font-medium"
                                        >
                                            Access Resource
                                            <i className="bi-arrow-right ml-2"></i>
                                        </a>
                                    ) : (
                                        <Link
                                            to={resource.path}
                                            className="inline-flex items-center text-green-600 hover:text-green-700 font-medium"
                                        >
                                            Access Resource
                                            <i className="bi-arrow-right ml-2"></i>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudentResources;
